import { get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Image from 'components/ImageV2';

const BackgroundImage = ({ asset }) => (
  <Image
    src={get(asset, ['file', 'url'])}
    alt={get(asset, ['description'])}
    width={get(asset, ['file', 'details', 'image', 'width'])}
    height={get(asset, ['file', 'details', 'image', 'height'])}
    coverParentNode
  />
);

BackgroundImage.propTypes = {
  asset: PropTypes.shape({
    file: PropTypes.shape({
      url: PropTypes.string.isRequired,
      details: PropTypes.shape({
        image: PropTypes.shape({
          width: PropTypes.number.isRequired,
          height: PropTypes.number.isRequired,
        }).isRequired,
      }),
    }),
    description: PropTypes.string,
  }).isRequired,
};

export default BackgroundImage;
